import {
	ref,
	get,
	update,
	runTransaction,
	getDatabase,
} from "firebase/database";

const database = getDatabase();
export const claimOffer = async ({ offerId, shopId, mobileNo }) => {
	try {
		const claimRef = ref(database, `claims/${offerId}/${mobileNo}`);

		const countRef = ref(
			database,
			`offers/byShop/${shopId}/${offerId}/claimCount`,
		);

		const existing = await get(claimRef);

		if (existing.exists() && existing.val().status === "claimed") {
			return {
				alreadyClaimed: true,
			};
		}

		await update(ref(database), {
			[`claims/${offerId}/${mobileNo}`]: {
				mobileNo,
				status: "claimed",
				claimedAt: Date.now(),
			},
		});

		await runTransaction(countRef, (current) => (current || 0) + 1);

		return {
			success: true,
		};
	} catch (err) {
		console.log(err);

		return {
			success: false,
		};
	}
};
